<div>
  <ng-container *ngIf="!expanded; else hideAdjournmentLinkContainer">
    <a [routerLink]="" (click)="onToggleAdjournmentHistoryButton(true)">
      Show adjournment history
      <mat-icon style="vertical-align: middle" class="icon" aria-hidden="true"
        >expand_more</mat-icon
      >
    </a>
  </ng-container>
  <ng-template #hideAdjournmentLinkContainer>
    <a [routerLink]="" (click)="onToggleAdjournmentHistoryButton(false)">
      Hide adjournment history
      <mat-icon style="vertical-align: middle" class="icon" aria-hidden="true"
        >expand_less</mat-icon
      >
    </a>
  </ng-template>
</div>
<div>
  <mat-accordion>
    <mat-expansion-panel
      style="box-shadow: none"
      [expanded]="expanded"
      hideToggle
    >
      <ng-container *ngFor="let hearingRequest of hearingHistory">
        <div class="mt-10">
          <jsg-action-hearing-details-tile-view
            [hearingRequest]="hearingRequest"
            [hearingDetailsRoute]="hearingDetailsRoute"
          >
          </jsg-action-hearing-details-tile-view>
        </div>
      </ng-container>
    </mat-expansion-panel>
  </mat-accordion>
</div>
